import React, { Component } from 'react';
import FieldLabel from 'src/Components/FieldLabel/FieldLabel';
import TextInput from 'src/Components/TextInput/TextInput';
import PrimaryButtonGE from 'src/Components/PrimaryButtonGE/PrimaryButtonGE';
import {
  faExclamationTriangle,
  faUser,
  faUsersCog,
  faEnvelope,
  faPhone,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './styles.scss';
import { validateEmail, validateName } from 'src/Utils';
import NavigateBack from 'src/Components/NavigateBack/NavigateBack';
import SecondaryButton from 'src/Components/SecondaryButton/SecondaryButton';
import info_icon from '../../Assets/Images/info_icon.svg';
import warning_icon from '../../Assets/Images/warning_icon.svg';
import ProgressButton from 'src/Components/progressbutton/progressButton';
import AddTeamMemberLoader from 'src/Components/AddTeamMemberLoader/AddTeamMemberLoader';
import DropdownField from 'src/Components/Dropdown/DropdownField';
import { AnalyticsService } from 'src/Analytics/AnalyticsService';
import { withTranslation } from 'react-i18next';
import { PulseLoader } from 'react-spinners';

class AddTeamMember extends Component {
  state = {
    headerText: this.props.t('formErrorText'),
    descriptionText: this.props.t('formErrorSubtext'),
    showOtherFields: false,
    showModal: false,
    activationKey: '',
    facilityName: 'Scripps Hospital of Valey',
    showInputError: false,
    viewType: 'add',
    selectedRole: null,
    isExpertEnabled: false,
    isTrainer: false,
    isNameAvailable: false,
    userRoles: ['PARTICIPANT'],
    loading: false,
    isEdit: false,
    rolesList: [
      {
        roleId: 1,
        roleName: this.props.t('user'),
        icon: faUser,
        description: this.props.t('participantRoleDesc'),
        personaList: ['PARTICIPANT'],
      },
      {
        roleId: 2,
        roleName: this.props.t('admin'),
        icon: faUsersCog,
        description: this.props.t('adminRoleDesc'),
        personaList: ['ADMIN'],
      },
    ],
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    const activationKey = this.getActivationKey();
    this.setState({ loading: true });
    this.props.manageSidemenu(true);
    this.props.getActivationKeyDetails(activationKey);
    this.props.getLanguageDetails();
    this.props.fetchRegexRequest();
    this.getViewType();
    this.props.resetValues();
    this.updateAnalytics();
    const { i18n } = this.props;
    const lang = localStorage.getItem('authLang')
    i18n.changeLanguage(lang);
    this.props.stopInitLoadingAction()
  }

  getActivationKey = () => {
    let activationKey;
    if (this.props.location && this.props.location.state) {
      activationKey = this.props.location.state.activationKey;
    } else {
      let path = window.location.pathname;
      if (path.endsWith('/')) {
        path = path.slice(0, path.length - 2);
      }
      activationKey = path.split('/').pop();
    }
    return activationKey;
  }

  updateAnalytics = () => {
    const category = window.location.href.replace(window.location.origin, '');
    let catName = category.replace('/', '');
    catName = catName.includes('/') ? catName.split('/') : catName;

    const digitalData = {
      page: {
        pageInfo: {
          domain: document.domain,
          location: document.location,
          pageName: 'Add Team Member',
          siteSection: 'Add Team Member',
          pageURL: document.URL,
        },
        category: {
          primaryCategory: Array.isArray(catName) ? catName[0] : catName,
          subCategory:
            Array.isArray(catName) && catName.length > 1 ? catName[1] : '',
          Product:
            Array.isArray(catName) && catName.length > 2 ? catName[2] : '',
          pageType: document.domain,
        },
      },
      user: {
        profile: {
          profileInfo: {
            loginStatus: 'logged in',
            profileID: this.props.subscription?.subscriptionInfo?.sfdcUserId,
          },
        },
      },
    };

    AnalyticsService.updateDigitalData(digitalData);
    AnalyticsService.trackEvent('setAnalyticsVariables');
    AnalyticsService.trackEvent('pageLoaded');
  };

  selectRole = (val) => {
    const { user, viewType } = this.state;
    const { isLoading } = this.props.admin;
    const { subscriptionInfo } = this.props.subscription;
    if (
      isLoading ||
      (viewType === 'edit' && user.emailId === subscriptionInfo.email)
    ) {
      return;
    } else {
      this.setState({
        selectedRole: val.roleId,
        userRoles: val.personaList,
      });
    }
  };

  getViewType = () => {
    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.activationKey &&
      this.props.location.state.facilityName
    ) {
      let { activationKey, facilityName, viewType, userEmail } =
        this.props.location.state;
      this.setState({ activationKey, facilityName, viewType, userEmail });

      if (viewType === 'add') {
        this.setState({ selectedRole: 1, loading: false });
      } else {
        this.handleClick(userEmail, activationKey);
      }
    } else {
      this.props.history.goBack();
    }
  };

  componentDidUpdate(prevProps) {
    const { t } = this.props;
    let { userValidationRes, userDetails, toastMessage } = this.props.admin;
    if (userValidationRes && (prevProps.admin.userValidationRes !== userValidationRes)) {
      switch (userValidationRes?.status) {
        case 'VALID_DE_USER_DIFFERENT_PARENT':
          this.setState({
            showInputError: true,
            displayError: true,
            loading: false,
            errorBlockType: 'red',
            typeError: 'different',
            headerText: t('userDiffParentHeader'),
            isEdit: false,
            descriptionText: t('userDiffParentDesc'),
          });
          break;
        case 'DISABLED_USER':
          this.setState({
            showInputError: true,
            displayError: true,
            loading: false,
            errorBlockType: 'blue',
            typeError: 'same',
            headerText: t('disabledUserHeader'),
            descriptionText: t('doYouWantMsg') + ' ',
            isEdit: true,
          });
          break;
        case 'EXISTING_USER':
          this.setState({
            showInputError: true,
            displayError: true,
            loading: false,
            errorBlockType: 'blue',
            typeError: 'same',
            headerText: t('existingUserHeader'),
            descriptionText: t('doYouWantMsg') + ' ',
            isEdit: true,
          });
          break;
        case 'INVALID_EMAIL_ID':
          this.setState({
            showInputError: true,
            displayError: true,
            loading: false,
            errorBlockType: 'red',
            typeError: 'different',
            headerText: t('formErrorText'),
            isEdit: false,
            descriptionText: t('invalidEmailIDDesc'),
          });
          break;
        case 'VALID_DE_USER':
        case 'VALID_USER_WITHOUT_DE':
          let name = userValidationRes.name.split('~');
          let isNameAvailable = name ? true : false;
          let { accrediting } = this.props.admin;
          this.setState({
            isNameAvailable,
          });
          const accBodyTypeKey =
            userValidationRes.hasOwnProperty('accreditingBodyType') &&
              userValidationRes.accreditingBodyType
              ? accrediting
                .filter(
                  (x) => x.key === userValidationRes.accreditingBodyType
                )
                .pop().key
              : accrediting[0].key;
          let newValue = {
            firstName: name[0],
            lastName: name[1],
            accBodyType: accBodyTypeKey,
            accBodyId: this.getAccBodyId(userValidationRes),
          };
          this.props.updateFieldValue(newValue);
          this.setState({
            showInputError: false,
            displayError: false,
            showOtherFields: true,
            loading: false,
          });
          break;
        default:
          this.setState({
            showInputError: false,
            displayError: false,
            showOtherFields: true,
            loading: false,
          });
      }
    }
    if (userDetails && (prevProps.admin.userDetails !== this.props.admin.userDetails)) {
      this.editViewTypeDetails(userDetails);
    }
    if (toastMessage && (prevProps.admin.toastMessage !== toastMessage)) {
      this.handleCancel();
    }
  }

  getAccBodyId = (userValidationRes) => {
    return (userValidationRes.hasOwnProperty('accreditingBodyId') &&
      userValidationRes.accreditingBodyId
      ? userValidationRes.accreditingBodyId
      : '');
  }
  editViewTypeDetails = (userDetails) => {
    let selectedRole = null;
    let userRoles = [];
    let isDisabled = true;
    let isExpertEnabled = false;
    let isTrainer = false;

    if (userDetails.entRoles) {
      isDisabled = false;
      isExpertEnabled = userDetails.entRoles.includes('TRAINER')
        ? true
        : false;
      isTrainer = userDetails.entRoles.includes('TRAINER') ? true : false;
      if (userDetails.entRoles.includes('ADMIN')) {
        selectedRole = 2;
        userRoles = ['ADMIN'];
      } else {
        selectedRole = 1;
        userRoles = ['PARTICIPANT'];
      }
    }
    this.setState({
      viewType: 'edit',
      loading: false,
      isDisabled: isDisabled,
      showOtherFields: true,
      selectedRole,
      isExpertEnabled,
      isTrainer,
      userRoles,
      user: userDetails,
    });
  }
  handleClick = (email, activationKey) => {
    this.props.getUserDetails(email, activationKey);
  };

  saveInputDetails = (type, e, item) => {
    let val = type === 'accBodyType' ||
      type === 'language' ? item.key : item;
    if (item) {
      this.props.updateError({ [type]: '' });
    }
    this.props.updateFieldValue({ [type]: val });
  };

  clickIcon = (item, errorMessage) => {
    this.props.updateFieldValue({ [item]: '' });
    if (item !== 'accBodyId') {
      this.props.updateError({ [item]: errorMessage });
    }
    if (document.getElementById(item)) {
      document.getElementById(item).focus();
    }
  };

  updateInputVal = (id, errorMessage) => {

    let { fieldValue } = this.props.admin;
    if ((id === 'firstName' || id === 'lastName') && fieldValue[id]) {
      this.props.updateFieldValue({
        [id]: fieldValue[id].trim().replace(/\s+/g, ' '),
      });
    }
    if ((id === 'language') && fieldValue[id]) {
      this.props.updateFieldValue({
        [id]: fieldValue[id],
      });
    }
    if (
      !fieldValue[id] ||
      ((id === 'firstName' || id === 'lastName') &&
        fieldValue[id] &&
        !fieldValue[id].trim())
    ) {
      this.props.updateError({ [id]: errorMessage });
    } else {
      this.validateProfileDetails(fieldValue);
    }
  };

  validateProfileDetails = (fieldValue) => {
    const { t } = this.props;
    let { regex } = this.props.admin;
    if (
      fieldValue['workEmailAddress'] &&
      !validateEmail(fieldValue['workEmailAddress'], regex)
    ) {
      this.props.updateError({
        ['workEmailAddress']: t('validWorkEmailAddError'),
      });
    }
    if (fieldValue['firstName'] && !validateName(fieldValue['firstName'])) {
      this.props.updateError({
        ['firstName']: t('validFirstNameError'),
      });
    }
    if (fieldValue['lastName'] && !validateName(fieldValue['lastName'])) {
      this.props.updateError({
        ['lastName']: t('validLastNameError'),
      });
    }
  }

  verifyEmailAddress = () => {
    let { formError, fieldValue } = this.props.admin;
    let { activationKey } = this.state;
    let errors = formError;
    const { t } = this.props;

    window.digitalData.link = {
      linkName: 'Continue',
      linkType: 'admin field wrapper',
    };

    AnalyticsService.trackEvent('link_click');

    if (!fieldValue['workEmailAddress'])
      errors['workEmailAddress'] = t('emptyWorkEmailAddError');
    this.props.updateError(errors);
    if (Object.keys(formError).length > 0) {
      this.setState({
        displayError: true,
        errorBlockType: 'red',
        isFieldsError: true,
        headerText: t('formErrorText'),
        descriptionText: t('formErrorSubtext'),
        fieldErrors: { ...formError },
        isEdit: false,
      });
    } else {
      this.setState({
        displayError: false,
        fieldErrors: {},
      });
      this.props.verifyEmailAddress(
        activationKey,
        '',
        fieldValue['workEmailAddress'].toLowerCase()
      );
    }
  };

  displayErrorBlock = () => {
    let {
      fieldErrors,
      errorBlockType,
      isFieldsError,
      headerText,
      descriptionText,
      typeError,
      activationKey,
      isEdit,
    } = this.state;
    let { fieldValue } = this.props.admin;
    const { t } = this.props;
    return (
      <div
        className="error-wrapper"
        style={{
          backgroundColor: errorBlockType === 'red' ? '#a80925' : '#046B91',
        }}
      >
        <img
          className="error-icon"
          src={errorBlockType === 'red' ? warning_icon : info_icon}
          color={'#D7D8DB'}
        />
        <div className="error-content">
          <p className="error-header">{headerText}</p>
          <p className="error-sub-value">
            {descriptionText}
            {typeError === 'same' && isEdit ? (
              <>
                <span
                  style={{ textDecoration: 'underline', cursor: 'pointer' }}
                  onClick={this.handleClick.bind(
                    this,
                    fieldValue['workEmailAddress'],
                    activationKey
                  )}
                >
                  {t('editAccText')}
                </span>
                ?
              </>
            ) : null}
          </p>
          {isFieldsError ? (
            <>
              {Object.keys(fieldErrors).map((i) => {
                return (
                  <div className="error-sub-value" key={i}>
                    • {`${t(i)}`}
                  </div>
                );
              })}
            </>
          ) : null}
        </div>
      </div>
    );
  };

  addUser = async () => {
    const { t } = this.props;
    let { fieldValue, userValidationRes, formError, accrediting, languages } = this.props.admin;
    let { activationKey, userRoles, isExpertEnabled } = this.state;
    let persona = isExpertEnabled ? userRoles.concat('TRAINER') : userRoles;
    const selectedKey =
      !_.isEmpty(fieldValue) && fieldValue.hasOwnProperty('accBodyType')
        ? accrediting.filter((x) => x.key === fieldValue.accBodyType).pop().key
        : accrediting[0];

    const selectedLanguageKey =
      !_.isEmpty(fieldValue) && fieldValue.hasOwnProperty('language')
        ? this.getLanguage(fieldValue, languages)
        : languages[0];

    fieldValue.hasOwnProperty('accreditingBodyType')
      ? await this.props.updateFieldValue({ ['persona']: persona })
      : await this.props.updateFieldValue({
        ['persona']: persona,
        ['accBodyType']:
          typeof selectedKey === 'object' ? selectedKey.key : selectedKey,
      });
    let errors = formError;
    if (!fieldValue['firstName'])
      errors['firstName'] = t('emptyFirstNameError');
    if (!fieldValue['lastName'])
      errors['lastName'] = t('emptyLastNameError');
    this.props.updateError(errors);

    window.digitalData.link = {
      linkName: 'Create Account',
      linkType: 'admin field wrapper',
    };

    AnalyticsService.trackEvent('link_click');

    if (Object.keys(formError).length > 0) {
      this.setState({
        displayError: true,
        errorBlockType: 'red',
        isFieldsError: true,
        headerText: t('formErrorText'),
        descriptionText: t('formErrorSubtext'),
        fieldErrors: { ...formError },
        isEdit: false,
      });
      window.scrollTo(0, 0);
    } else {
      let req = {
        accBodyType: this.addUserAccBodyType(fieldValue, selectedKey),
        accBodyId: fieldValue.hasOwnProperty('accBodyId')
          ? fieldValue.accBodyId
          : '',
        activationKey: activationKey,
        emailId: fieldValue.workEmailAddress.toLowerCase(),
        language: selectedLanguageKey.key,
        firstName: fieldValue.firstName,
        lastName: fieldValue.lastName,
        persona,
        sfdcProfileStatus: userValidationRes.status,
      };
      this.setState({
        displayError: false,
        fieldErrors: {},
      }, () => {
        this.props.addTeamMember(req, false);
      });
    }
  };

  addUserAccBodyType = (fieldValue, selectedKey) => {
    if (fieldValue.hasOwnProperty('accBodyType')) {
      return (fieldValue.accBodyType);
    }
    return (typeof selectedKey === 'object' ? selectedKey.key : selectedKey);
  }

  updateUserDetails = async () => {
    let { activationKey, userRoles, isExpertEnabled, user } = this.state;
    let persona = isExpertEnabled ? userRoles.concat('TRAINER') : userRoles;
    await this.props.updateFieldValue({ ['persona']: persona });

    window.digitalData.link = {
      linkName: 'Save Changes',
      linkType: 'admin field wrapper',
    };

    AnalyticsService.trackEvent('link_click');

    let req = {
      accBodyType: user.accreditingBodyType,
      accBodyId: user.accreditingBodyId,
      activationKey: activationKey,
      emailId: user.emailId,
      firstName: user.firstName,
      language: user.language,
      lastName: user.lastName,
      persona: this.props.admin.fieldValue.persona,
      sfdcProfileStatus: 'VALID_DE_USER',
    };
    this.props.addTeamMember(req, true);
  };

  componentWillUnmount() {
    this.props.manageSidemenu(false);
  }
  handleCancel = () => {
    window.digitalData.link = {
      linkName: 'Cancel',
      linkType: 'Admin Header',
    };

    AnalyticsService.trackEvent('link_click');

    this.props.resetValues();
    this.props.history.goBack();
  };

  manageUser = (isDisabled) => {
    let { activationKey, user } = this.state;
    const { subscriptionInfo } = this.props.subscription;

    if (isDisabled) {
      window.digitalData.link = {
        linkName: 'Enable Digital Expert Access',
        linkType: 'admin body container',
      };
    } else {
      window.digitalData.link = {
        linkName: 'Disable Digital Expert Access',
        linkType: 'user header',
      };
    }

    if (user.emailId === subscriptionInfo.email && !isDisabled) {
      return;
    } else {
      this.props.updateUser(activationKey, isDisabled, user.emailId);
    }

    AnalyticsService.trackEvent('link_click');
  };

  setErrorMessage = (message, text, color) => {
    let a = new RegExp(text, 'gi');
    const formattedStr = message.replace(
      a,
      (changedText) =>
        `<a href="https://www.gehealthcare.com/products/ultrasound/ultrasound-digital-solutions/digital-expert" target="_blank" style=color:${color};text-decoration:none>${changedText}</a>`
    );
    return <span dangerouslySetInnerHTML={{ __html: formattedStr }} />;
  };

  renderNavigateBackBtn = () => {
    const { isLoading = false } = this.props.admin;
    return isLoading ? <NavigateBack isDisabled={true} /> : <NavigateBack />
  }

  getLanguage(fieldValue, languages) {
    if (fieldValue.language !== 'null' &&
      fieldValue.language !== null && fieldValue.language !== 'undefined' && fieldValue.language !== '') {
      return (
        languages
          .filter((x) => x.key === fieldValue.language)
          .pop()
      );
    }
    else {
      return (
        languages[0]
      );
    }
  }

  renderAdminField = () => {   let {
    fieldValue = {},
    formError = {},
    isLoading = false,
    accrediting,
    languages,
    } = this.props.admin;
    let {
      viewType,
      user,
      isNameAvailable,
    } = this.state;
    const { t } = this.props;
    let selectedKey = this.getSelectedKey(fieldValue, accrediting);
    let selectedLanguageKey = this.getSelectedLanguageKey(fieldValue, languages);
    let { formErrorLastName, formErrorFirstName, formErroraccBodyType } = this.getFormErrors(formError);
    let { fieldValueLastName, fieldValueFirstName, fieldValueAccBodyId } = this.getFieldValues(fieldValue);
    let availableLanguages = this.getLanguagesList(languages);
    let accreditingBody = this.getAccreditingBody(accrediting);
    let userName = this.getUserName(user);
    let accountName = this.getAccountName(user);
    let userEmailId = this.getUserEmailId(user);
    let userWorkPhoneNumber = this.getWorkPhoneNumber(user);
    if(viewType === 'add') 
    {
      return (
      <>
        <div className="admin-field-container">
          <div className="input-field-wrapper">
            <FieldLabel
              labelText={t('firstName')}
              isDisabled={isLoading}
            />
            <TextInput
              id="firstName"
              className="textfield-style"
              onChange={this.saveInputDetails.bind(
                this,
                'firstName'
              )}
              inputValue={fieldValueFirstName}
              iconClick={this.clickIcon.bind(
                this,
                'firstName',
                t('emptyFirstNameError')
              )}
              onBlur={this.updateInputVal.bind(
                this,
                'firstName',
                t('emptyFirstNameError')
              )}
              isError={!!formError.firstName}
              errorMessage={formErrorFirstName}
              isDisabled={isLoading || isNameAvailable}
            />
          </div>
        </div>
        <div className="admin-field-container">
          <div className="input-field-wrapper">
            <FieldLabel
              labelText={t('lastName')}
              isDisabled={isLoading}
            />
            <TextInput
              id="lastName"
              className="textfield-style"
              onChange={this.saveInputDetails.bind(
                this,
                'lastName'
              )}
              inputValue={fieldValueLastName}
              iconClick={this.clickIcon.bind(
                this,
                'lastName',
                t('emptyLastNameError')
              )}
              onBlur={this.updateInputVal.bind(
                this,
                'lastName',
                t('emptyLastNameError')
              )}
              isError={!!formError.lastName}
              errorMessage={formErrorLastName}
              isDisabled={isLoading || isNameAvailable}
            />
          </div>
        </div>
        <div className="admin-field-container">
          <div className="input-field-wrapper">
            <FieldLabel
              labelText={t('language')}
              isDisabled={isLoading}
            />
            <DropdownField
              id="language"
              onChange={this.saveInputDetails.bind(this, 'language')}
              options={availableLanguages}
              inputValue={selectedLanguageKey && selectedLanguageKey.key}
              isDisabled={isLoading || availableLanguages.length === 1 ? true : false}
              isError={false}
              shadow={true}
            />
          </div>
        </div>
        <div className="admin-field-container">
          <div className="input-field-wrapper">
            <div className="accred-field-label">
              <FieldLabel
                labelText={t('accBodyID')}
                isRequired={false}
                isDisabled={isLoading}
              />
            </div>
            <div className="accred-drop-down">
              <DropdownField
                id="accBodyType"
                className="textfield-style"
                onChange={this.saveInputDetails.bind(
                  this,
                  'accBodyType'
                )}
                inputValue={selectedKey.key}
                options={accreditingBody}
                isDisabled={isLoading}
                isError={!!formError.accBodyType}
                errorMessage={formErroraccBodyType}
              />
            </div>
            <div className="accred-text-field">
              <TextInput
                id="accBodyId"
                className="textfield-style"
                onChange={this.saveInputDetails.bind(
                  this,
                  'accBodyId'
                )}
                inputValue={fieldValueAccBodyId}
                iconClick={this.clickIcon.bind(
                  this,
                  'accBodyId'
                )}
                onBlur={this.updateInputVal.bind(this, '', '')}
                isError={false}
                isRequired={false}
                isDisabled={isLoading}
                placeholder={'1234'}
              />
            </div>
          </div>
        </div>
      </>
    )} else {
      return (
      <div className="user-info-container">
        <div className="account-logo">
          <p className="account-initial">
            {userName}
          </p>
        </div>
        <p className="account-name">
          {accountName}
        </p>
        <p className="account-title">
          {this.renderAccountTitle(user)}
        </p>
        <div className="details-wrapper">
          <div className="details-info">
            <FontAwesomeIcon
              icon={faEnvelope}
              color={'#D7D8DB'}
            />
            <p className="details-text">
              {userEmailId}
            </p>
          </div>
          <div className="details-info">
            <FontAwesomeIcon icon={faPhone} color={'#D7D8DB'} />
            <p className="details-text">
              {userWorkPhoneNumber}
            </p>
          </div>
        </div>
      </div>
    )}
  }

  renderViewType = () => {    
  let {
    isLoading = false,
    isEmailVerifying,
  } = this.props.admin;
  let {
    viewType,
    user,
    isDisabled,
  } = this.state;
  const { subscriptionInfo } = this.props.subscription;
  const { t } = this.props;
  let truncatedName = user?.firstName + ' ' + user?.lastName;
  let cancelButton;
  if(isEmailVerifying || isLoading){
    cancelButton = (
      <p className="cancel-button-disabled">{t('cancel')}</p>
    ) 
  }else{ 
    cancelButton = (
      <p className="cancel-button" onClick={this.handleCancel}>
        {t('cancel')}
      </p>
    );
  }
    
    if (viewType === 'add'){ 
      return (
      <div className="admin-header">
        <p className="facility-name">{t('addNewMemberText')}</p>
        {cancelButton}
      </div>
      )
    }else{
      return (
        <div className="user-header">
          {this.renderNavigateBackBtn()}
          <div className="user-name-text">
            <p className="add-user-name">
              {user && truncatedName}
            </p>
          </div>
          {viewType === 'edit' && user && !isDisabled && (
            <div className="disable-access-btn">
              <PrimaryButtonGE
                disabled={
                  user.emailId === subscriptionInfo.email || isLoading
                }
                className="disable-btn"
                text={t('disableDEAccessText')}
                onClick={this.manageUser.bind(this, false)}
              />
            </div>
          )}
        </div>
      )
    }
  }

  

  getSelectedKey = (fieldValue, accrediting) => {
    if(!_.isEmpty(fieldValue) && fieldValue.hasOwnProperty('accBodyType'))
      return accrediting.filter((x) => x.key === fieldValue.accBodyType).pop();
    else return accrediting[0];
  }

  getSelectedLanguageKey = (fieldValue, languages) => {
    if(!_.isEmpty(fieldValue) && fieldValue.hasOwnProperty('language'))
      return this.getLanguage(fieldValue, languages);
    else return languages[0];
  }

  getWorkEmail = (fieldValue) => {
    if(fieldValue) return fieldValue.workEmailAddress ;
    else return '';
  }

  getFormErrors = (formError) => {  
    if(formError) {
      return {
        formErrorWorkEmailAddress: formError.workEmailAddress,
        formErrorLastName: formError.lastName,
        formErrorFirstName: formError.firstName,
        formErroraccBodyType: formError.accBodyType,
      };
    } else {
      return {
        formErrorWorkEmailAddress: '',
        formErrorLastName: '',
        formErrorFirstName: '',
        formErroraccBodyType: '',
      }
    }
  }

  getFieldValues = (fieldValue, accrediting) => { 
    if(fieldValue) {
      return {
        fieldValueLastName: fieldValue.lastName,
        fieldValueFirstName: fieldValue.firstName,
        fieldValueAccBodyId: fieldValue.accBodyId,
      }
    } else {
      return {
        fieldValueLastName: '',
        fieldValueFirstName: '',
        fieldValueAccBodyId: '',
      }
    }
  }

  getLanguagesList = (languages) => {
    if(languages) return languages;
    else return [];
  }

  getAccreditingBody = (accrediting) => {
    if(accrediting) return accrediting;
    else return [];
  }

  getUserName = (user) => {
    let userName;
    if(user?.firstName) userName = user.firstName.charAt(0);
    else userName = '';

    if(user?.lastName) userName = userName + user.lastName.charAt(0);
    else userName = userName + '';

    return userName;
  }

  getAccountName = (user) => {
    let truncatedName = user?.firstName + ' ' + user?.lastName;
    if(user) return truncatedName;
    else return '';
  }

  getUserEmailId = (user) => {
    if(user?.emailId) return user.emailId;
    else return '-';
  }

  getWorkPhoneNumber = (user) => {
    if(user?.workPhoneNumber && (user.workPhoneNumber !== '' || user.workPhoneNumber !== 'null'))
      return user.workPhoneNumber;
    else return '-';
  }

  getAccountMode = (viewType) => {
    const { t } = this.props;
    if(viewType === 'add') return t('creatingAccount') + '...';
    else return t('savingAccount') + '...';
  }  

  getFieldList = (showOtherFields, isLoading, viewType, accountMode, isEmailVerifying) => {
    const { t } = this.props;
    if(showOtherFields) return this.renderShowOtherFields(isLoading, viewType, t, accountMode);
    else return this.renderContinueButton(viewType, t, isEmailVerifying);
  }  

  checkSelectedRole = (selectedRole, roleId) => {
    if (selectedRole === roleId) return 'checked';
    else return null;
  }

  getColor = (isLoading, viewType, user, subscriptionInfo) => {
    if(isLoading || (viewType === 'edit' && user.emailId === subscriptionInfo.email)) return '#63666A';
    else return '#FAFBFD';
  }

  renderContent = () => {
    let {
      fieldValue = {},
      formError = {},
      isLoading = false,
      isEmailVerifying,
    } = this.props.admin;
    let { activationKeyDetails } = this.props.customer;
    let {
      displayError,
      showOtherFields,
      showInputError,
      rolesList,
      selectedRole,
      viewType,
      user,
      isDisabled,
      loading,
    } = this.state;
    const { subscriptionInfo } = this.props.subscription;
    const { t } = this.props;
    let workEmailAddress = this.getWorkEmail(fieldValue);
    let { formErrorWorkEmailAddress } = this.getFormErrors(formError);
    let accountMode = this.getAccountMode(viewType);
    let showFields = this.getFieldList(showOtherFields, isLoading, viewType, accountMode, isEmailVerifying);
    if (loading) 
      return (
          <div className="admin-body-loading">
            <AddTeamMemberLoader />
          </div>
        )
      else 
        return (
        <div className="admin-body-container">
          <div className="admin-body-wrapper">
            {viewType === 'add' && (
              <>
                <div className="admin-title">{t('addTeamMemberHeader')}</div>
                {displayError && (
                  <div className="admin-error-wrapper">
                    {this.displayErrorBlock()}
                  </div>
                )}
                <div className="admin-field-wrapper">
                  <p className="sub-header-text contact-text">
                    {t('contactInfoText')}
                  </p>
                </div>
                <div className="admin-field-wrapper">
                  <div className="input-field-wrapper">
                    <FieldLabel
                      labelText={t('workEmailAddress')}
                      isDisabled={isEmailVerifying || showOtherFields}
                    />
                    <TextInput
                      id="workEmailAddress"
                      className="textfield-style"
                      onChange={this.saveInputDetails.bind(
                        this,
                        'workEmailAddress'
                      )}
                      inputValue={workEmailAddress}
                      iconClick={this.clickIcon.bind(
                        this,
                        'workEmailAddress',
                        t('emptyWorkEmailAddError')
                      )}
                      onBlur={this.updateInputVal.bind(
                        this,
                        'workEmailAddress',
                        t('emptyWorkEmailAddError')
                      )}
                      isError={
                        (!!formError.workEmailAddress || showInputError) &&
                        !showOtherFields
                      }
                      errorMessage={formErrorWorkEmailAddress}
                      isDisabled={isEmailVerifying || showOtherFields}
                    />
                  </div>
                </div>
              </>
            )}
            {showOtherFields && (
              <>
                {viewType === 'add' && (
                  <div className="admin-field-wrapper">
                    <p className="sub-header-text personal-text">
                      {t('personalInfoText')}
                    </p>
                  </div>
                )}
                <div className="admin-field-wrapper">
                  {this.renderAdminField()}

                  {viewType === 'add' ||
                    (viewType === 'edit' && !isDisabled) ? (
                    <>
                      <div className={'admin-field-wrapper'}>
                        <p className="sub-header-text role-text">{t('colRole')}</p>
                        <p className="info-text">
                          {t('roleDesc')}
                        </p>
                      </div>
                      <div
                        className={
                          this.renderDisabledStyles(isLoading, viewType, user, subscriptionInfo)
                        }
                      >
                        {rolesList.map((i, index) => {
                          return (
                            <div
                              className={`subscription-list-wrapper`}
                              onClick={this.selectRole.bind(this, i)}
                              key={i}
                            >
                              <div
                                className={`subscription-select-wrapper subscription-select-wrapper-${selectedRole === i.roleId
                                  }`}
                              >
                                <div className="subscription-select">
                                  <label htmlFor={i.roleId}>
                                    <input
                                      type="radio"
                                      className="radio-select"
                                      value={i.roleId}
                                      id={i.roleId}
                                      name="susbcription"
                                      checked={this.checkSelectedRole(selectedRole, i.roleId)}
                                      onChange={this.selectRole.bind(this, i)}
                                    />
                                    <span></span>
                                  </label>
                                </div>
                                <div className={`user-icon-wrapper`}>
                                  <FontAwesomeIcon
                                    className="role-icon"
                                    icon={i.icon}
                                    color={this.getColor(isLoading, viewType, user, subscriptionInfo)}
                                  />
                                </div>
                                <div className="facility-details">
                                  <p className="facility-name">
                                    {i.roleName}
                                  </p>
                                  <p className="facility-address">
                                    {i.description}
                                  </p>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      {activationKeyDetails?.status
                        .collabSubscriptionStatus === 'EXPIRED' && (
                          <div className="admin-field-wrapper">
                            <div className="collaboration-error-container">
                              <p
                                className="error-message"
                                style={{ color: '#DF4661' }}
                              >
                                <FontAwesomeIcon
                                  icon={faExclamationTriangle}
                                  color={'#DF4661'}
                                />
                                {this.setErrorMessage(
                                  t('C2CExpiredText'),
                                  t('contactGEText'),
                                  '#51BDDF'
                                )}
                              </p>
                            </div>
                          </div>
                        )}
                    </>
                  ) : (
                    <div>
                      <PrimaryButtonGE
                        className="enable-btn"
                        text={t('enableDEAccessText')}
                        onClick={this.manageUser.bind(this, true)}
                      />
                    </div>
                  )}
                </div>
              </>
            )}
            <div className="admin-field-wrapper">
              {(viewType === 'add' ||
                (viewType === 'edit' && !isDisabled)) && (
                  <>
                    {showFields}
                    {viewType !== 'add' && user && (
                      <SecondaryButton
                        disabled={
                          user.emailId === subscriptionInfo.email || isLoading
                        }
                        text={t('disableDEAccessText')}
                        onClick={this.manageUser.bind(this, false)}
                      />
                    )}
                  </>
                )}
            </div>
          </div>
        </div>
      )
  }

  render() {

    return (
      <div className="new-customer-container">
        {this.props.generic.initialLoad ? 
        <div className='init-loader'><PulseLoader color={'#ffffff'} style={{ marginBottom: 24, marginTop: 24 }} /></div> : <>
        {this.renderViewType()}
        {this.renderContent()}
        </>}
      </div>
    );
  }

  renderAccountTitle = (user) => {
    const { t } = this.props;
    let userDept = user['department']
      ? ` ${t('In')} ${user['department']}`
      : '-';
    return (user['jobTitle'] ? (
      <>
        <span>{user.jobTitle}</span>
        {userDept}
      </>
    ) : (
      <>
       -
      </>
    ));
  }

  renderShowOtherFields = (isLoading, viewType, t, accountMode) => {
    return (
      <div className="button-wrapper">
        {isLoading ? (
          <ProgressButton
            text={accountMode}
          />
        ) : (
          <>
            {this.renderButton(viewType, t)}
          </>
        )}
      </div>
    );
  }

  renderButton = (viewType, t) => {
    if (viewType === 'add') {
      return (<PrimaryButtonGE
        className="create"
        text={t('createAccount')}
        onClick={this.addUser}
      />);
    } else {
      return (<PrimaryButtonGE
        className="save-btn"
        text={t('saveChanges')}
        onClick={this.updateUserDetails}
      />);
    }
  }

  renderContinueButton = (viewType, t, isEmailVerifying) => {
    let verifyEmail = isEmailVerifying ? (
      <ProgressButton text={t('continue')} />
    ) : (
      <PrimaryButtonGE
        className="continue"
        text={t('continue')}
        onClick={this.verifyEmailAddress}
      />
    );
    return(
    <>
      {viewType === 'add' && (
        <div className="button-wrapper">
          {verifyEmail}
        </div>
      )}
    </>);
  }

  renderDisabledStyles = (isLoading, viewType, user, subscriptionInfo) =>{
    if(isLoading || (viewType === 'edit' && user.emailId === subscriptionInfo.email)){
      return ('admin-field-wrapper disabled-styles');
    } 
    return'admin-field-wrapper';
  }
}

export default withTranslation()(AddTeamMember);
